// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/sysSetting',
    name: 'SysSetting',
    component: layout,
    redirect: '/sysSetting/device',
    meta: {
      title: '系统管理',
      icon: 'i-tabler:settings',
      roles: [0]
    },
    sort: 9,
    children: [
      {
        path: 'device',
        name: 'SysDevice',
        component: () => import('@/views/Manage/Device.vue'),
        meta: {
          title: '设备列表',
          icon: 'i-tabler:device-desktop',
          roles: [0]
        }
      },
      {
        path: 'model',
        name: 'SysModelManage',
        component: () => import('@/views/Manage/Model.vue'),
        meta: {
          title: '模型列表',
          icon: 'i-tabler:brand-adobe-illustrator',
          roles: [0]
        }
      },
      {
        path: 'brand',
        name: 'SysBrand',
        component: () => import('@/views/Manage/Brand.vue'),
        meta: {
          title: '品牌列表',
          icon: 'i-tabler:brand-abstract',
          roles: [0]
        }
      },
      {
        path: 'taskUrl',
        name: 'SysTaskUrl',
        component: () => import('@/views/Manage/TaskUrl.vue'),
        meta: {
          title: '信源网站列表',
          icon: 'i-tabler:link',
          roles: [0]
        }
      }
    ]
  }
]
export default routes
